const Tours =
{
  tour1: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00001%2F01.jpg?alt=media&token=1c00d81c-53f5-46fd-b56d-c7deb8bce230',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00001%2F02.jpg?alt=media&token=a0b276fa-f21b-48e2-be11-9d20ada195ac',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00001%2F03.jpg?alt=media&token=dc5cf229-8e8b-44e1-a9a7-34a58262b216',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00001%2F04.jpg?alt=media&token=5dd3e1c1-d4cc-427b-a291-3fbd748d4723',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00001%2F05.jpg?alt=media&token=151a632a-96a5-43cf-abe4-0106c8364843',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-3.0863 -1.6 7.9199",
        cameraRotation: "1.9860"
      },
      {
        from: "01",
        to: "03",
        hotspotPosition: "-8.446 0 -1.6.9567",
        cameraRotation: "-1.0080"
      },
      {
        from: "01",
        to: "04",
        hotspotPosition: "-5.3843 -1.6 -6.5772",
        cameraRotation: "-0.0620"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "1.2534 -1.6 -8.4071",
        cameraRotation: "-1.6220"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "7.9346 -1.6 -3.0483",
        cameraRotation: "-0.7740"
      },
      {
        from: "02",
        to: "05",
        hotspotPosition: "-8.4762 -1.6 -0.6352",
        cameraRotation: "1.5220"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "-7.8592 -1.6 -3.2379",
        cameraRotation: "2.7960"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-0.879 -1.6 8.4544",
        cameraRotation: "4.6260"
      },
      {
        from: "03",
        to: "01",
        hotspotPosition: "-5.3948 -1.6 6.5686",
        cameraRotation: "4.6260"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Gold Coast',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Gold Coast',
      whatsapp    : '+593992576900',
      date        : '2021 - 01 - 12',
      ambiente    : 'terraza',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'gold coast terraza',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0001.jpg?alt=media&token=4afe6286-0e42-4b52-84cd-b978862016e0',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0001.jpg?alt=media&token=4afe6286-0e42-4b52-84cd-b978862016e0'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    },
    credits     :
    {
      creator   : 'entorno',
      urlPC     : '',
      urlPhone  : '',
    }
  },
  tour2: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00002%2F01.jpg?alt=media&token=d8a941ec-9748-4b7e-927b-ca6863228381',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00002%2F02.jpg?alt=media&token=7075b113-f60f-4e76-8243-bad358ae23ec',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00002%2F03.jpg?alt=media&token=c42048df-10d0-484a-9fa5-8fa7a76d8d13',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00002%2F04.jpg?alt=media&token=7c80bdfa-ab30-4172-8bfc-68ffb1af0770',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00002%2F05.jpg?alt=media&token=45280e04-c698-4456-9b85-44de48b97d6e',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00002%2F06.jpg?alt=media&token=138385f8-b570-488e-944e-2ccf7dc0f872',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "1.1019 -1.6 -8.4283",
        cameraRotation: "-1.7260"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "8.2816 -1.6 1.9147",
        cameraRotation: "-1.7300"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "-8.3278 -1.6 -1.7021",
        cameraRotation: "-3.2320"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "8.3843 -1.6 1.3979",
        cameraRotation: "-4.8600"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "-8.4413 -1.6 -0.9974",
        cameraRotation: "-4.8500"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "-8.4318 -1.6 -1.0749",
        cameraRotation: "-3.2200"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "8.4677 -1.6 0.7403",
        cameraRotation: "-4.9580"
      },
      {
        from: "01",
        to: "06",
        hotspotPosition: "-6.9456 -1.6 4.8999",
        cameraRotation: "-7.8820"
      },
      {
        from: "06",
        to: "01",
        hotspotPosition: "-8.4892 -1.6 0.4281",
        cameraRotation: "-7.7020"
      }
    ]  ,
    info        :
    {
      type        : 'project',
      name        : 'Gold Coast',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Gold Coast',
      whatsapp    : '+593992576900',
      date        : '2021 - 01 - 12',
      ambiente    : 'entrada',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'gold coast entrada',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0002.jpg?alt=media&token=3bda6e74-f7f5-46a4-9442-b139a42df325',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0002.jpg?alt=media&token=3bda6e74-f7f5-46a4-9442-b139a42df325'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour3: 
  {
    panoramas   :
    {
      pano01:
      {
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F01.jpg?alt=media&token=9dc6b843-9145-4056-b464-76c1d9ea55fa',
      },
      pano02:
      {
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F02.jpg?alt=media&token=3b1faa04-f606-43d9-a9ca-b9fd545143a4',
      },
      pano03:
      {
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F03.jpg?alt=media&token=7f3e99dc-b20c-42a6-a551-0fd1731ecc3a',
      },
      pano04:
      {
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F04.jpg?alt=media&token=2e8c3027-64ee-445f-864b-01448cc7b57c',
      },
      pano05:
      {
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F05.jpg?alt=media&token=13e1d78d-ef13-424e-a4ce-db5f7001fee2',
      },
      pano06:
      {
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F06.jpg?alt=media&token=2bd631bc-df04-4d72-89d6-44902c35feb8',
      },
      pano07:
      {
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00003%2F07.jpg?alt=media&token=93daefb8-6317-4e26-a969-add814f41048',
      },
    },
    hotspots    :
    [
      {
        from: "03",
        to: "01",
        hotspotPosition: "-1.1995 -1.6 8.4149",
        cameraRotation: "2.8140"
      },
      {
        from: "01",
        to: "03",
        hotspotPosition: "-1.4114 -1.6 -8.382",
        cameraRotation: "0.1320"
      },
      {
        from: "01",
        to: "02",
        hotspotPosition: "7.0363 -1.6 -4.7686",
        cameraRotation: "1.3700"
      },
      {
        from: "01",
        to: "05",
        hotspotPosition: "-3.118 -1.6 7.9075",
        cameraRotation: "-0.6600"
      },
      {
        from: "05",
        to: "01",
        hotspotPosition: "-7.6493 -1.6 3.7064",
        cameraRotation: "-0.7280"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.481 -1.6 -0.5673",
        cameraRotation: "-3.5960"
      }      
    ],
    info        :
    {
      type        : 'apartment',
      name        : 'Ilalo Gardens',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del apartamento modelo de 1 dormitorio de Ilalo Gardens',
      whatsapp    : '+593985323724',
      date        : '2021 - 07 - 12',
      ambiente    : 'apartamento',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'ilalo gardens apartamento modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0003.jpg?alt=media&token=a9330c8b-1087-4e61-a9e3-fc0774eb2a48',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0003.jpg?alt=media&token=a9330c8b-1087-4e61-a9e3-fc0774eb2a48'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour4: 
  {
    panoramas   :
    {
      pano01:
      {
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F01.jpg?alt=media&token=12514051-2aa3-482e-8a3d-30c34f168463',
      },
      pano02:
      {
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F02.jpg?alt=media&token=dd3238c7-82ef-4745-8b70-31950f0d4eae',
      },
      pano03:
      {
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F03.jpg?alt=media&token=475984c3-1856-4a9b-9b1c-4945d2206947',
      },
      pano04:
      {
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F04.jpg?alt=media&token=4111b0da-773d-4b54-b771-5a032709c3d5',
      },
      pano05:
      {
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F05.jpg?alt=media&token=23c09366-a745-47d5-aaa4-20349cc9b34f',
      },
      pano06:
      {
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F06.jpg?alt=media&token=7579a861-ff31-4bd1-95f0-08e62207ca93',
      },
      pano07:
      {
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F07.jpg?alt=media&token=3492598a-11f2-4a45-acda-f73c5dc5397c',
      },
      pano08:
      {
        pano  : '08',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F08.jpg?alt=media&token=24ade67c-4ac5-448d-ba92-35c268c77a70',
      },
      pano09:
      {
        pano  : '09',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F09.jpg?alt=media&token=5c96f3f8-0e07-478c-84fe-abe1c408a24a',
      },
      pano10:
      {
        pano  : '10',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00004%2F10.jpg?alt=media&token=47f335e5-f96d-4753-972a-afbfe814656c',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-8.4949 -1.6 -0.2957",
        cameraRotation: "1.5600"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.4921 -1.6 0.3671",
        cameraRotation: "-1.5720"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-8.4907 -1.6 -0.3976",
        cameraRotation: "1.6200"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "8.3615 -1.6 -1.5284",
        cameraRotation: "-1.6360"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-8.4292 -1.6 1.0952",
        cameraRotation: "1.5600"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "8.4335 -1.6 1.0615",
        cameraRotation: "-1.3620"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "-8.4618 -1.6 -0.8046",
        cameraRotation: "1.5540"
      },
      {
        from: "05",
        to: "04",
        hotspotPosition: "8.4949 -1.6 -0.2957",
        cameraRotation: "-1.7220"
      },
      {
        from: "05",
        to: "06",
        hotspotPosition: "-8.4996 -1.6 0.0782",
        cameraRotation: "-4.6920"
      },
      {
        from: "06",
        to: "05",
        hotspotPosition: "8.4936 -1.6 -0.3297",
        cameraRotation: "-1.6140"
      },
      {
        from: "06",
        to: "07",
        hotspotPosition: "-8.4905 -1.6 0.4011",
        cameraRotation: "1.5900"
      },
      {
        from: "07",
        to: "06",
        hotspotPosition: "8.4762 -1.6 -0.6352",
        cameraRotation: "4.7180"
      },
      {
        from: "07",
        to: "08",
        hotspotPosition: "-8.4998 -1.6 -0.0578",
        cameraRotation: "7.8840"
      },
      {
        from: "08",
        to: "07",
        hotspotPosition: "8.4915 -1.6 -0.3806",
        cameraRotation: "-1.6480"
      },
      {
        from: "08",
        to: "09",
        hotspotPosition: "-8.4935 -1.6 0.3331",
        cameraRotation: "-4.6780"
      },
      {
        from: "09",
        to: "08",
        hotspotPosition: "8.4988 -1.6 -0.1428",
        cameraRotation: "-1.6140"
      },
      {
        from: "09",
        to: "10",
        hotspotPosition: "-8.499 -1.6 0.1292",
        cameraRotation: "-3.1520"
      },
      {
        from: "10",
        to: "09",
        hotspotPosition: "0.136 -1.6 -8.4989",
        cameraRotation: "-1.5460"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Parques de Galicia 2',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Parques de Galicia 2',
      whatsapp    : '+593985323724',
      date        : '2021 - 07 - 12',
      ambiente    : 'parqueadero',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'ilalo gardens apartamento modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0004.jpg?alt=media&token=820c78c8-79ee-4824-9e23-523ba1f461c6',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0004.jpg?alt=media&token=820c78c8-79ee-4824-9e23-523ba1f461c6'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour5: 
  {
    panoramas   :
    {
      pano01:
      {
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F01.jpg?alt=media&token=73804efe-465f-47ba-bfa6-7c8273b3edc9',
      },
      pano02:
      {
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F02.jpg?alt=media&token=5059b5e1-e87a-4dd8-97e6-d15a398a03a7',
      },
      pano03:
      {
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F03.jpg?alt=media&token=d74a4e23-321f-4e54-8408-572bcf3c069b',
      },
      pano04:
      {
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F04.jpg?alt=media&token=d35e147a-c473-4ab6-aac1-80f3f30b69fc',
      },
      pano05:
      {
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F05.jpg?alt=media&token=8ed577e4-0bbc-48b1-9660-ce7949f114ed',
      },
      pano06:
      {
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F06.jpg?alt=media&token=9efdf874-0b6d-4f7c-a5ff-abd5c41c130d',
      },
      pano07:
      {
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00005%2F07.jpg?alt=media&token=9f0e7ee7-f53e-4d14-93a4-04dd30cdb3fa',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "03",
        hotspotPosition: "2.2016 0 -8.2099",
        cameraRotation: "-1.6280"
      },
      {
        from: "03",
        to: "01",
        hotspotPosition: "-8.4665 0 -0.7538",
        cameraRotation: "-3.2220"
      },
      {
        from: "03",
        to: "05",
        hotspotPosition: "4.4428 0 -7.2465",
        cameraRotation: "-1.8720"
      },
      {
        from: "05",
        to: "03",
        hotspotPosition: "-7.7234 0 -3.5496",
        cameraRotation: "-3.2400"
      },
      {
        from: "05",
        to: "07",
        hotspotPosition: "-2.0996 0 8.2366",
        cameraRotation: "-1.5880"
      },
      {
        from: "05",
        to: "01",
        hotspotPosition: "-2.6415 0 -8.0791",
        cameraRotation: "-3.1480"
      },
      {
        from: "07",
        to: "05",
        hotspotPosition: "-8.0225 0 -2.809",
        cameraRotation: "-0.2220"
      },
      {
        from: "01",
        to: "05",
        hotspotPosition: "-3.4815 0 -7.7543",
        cameraRotation: "-3.0540"
      } 
    ],
    info        :
    {
      type        : 'house',
      name        : 'Ilalo Gardens',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información de la casa modelo de 3 dormitorios de Ilalo Gardens',
      whatsapp    : '+593985323724',
      date        : '2021 - 07 - 12',
      ambiente    : 'casa',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'ilalo gardens casa modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0005.jpg?alt=media&token=6de8aa15-4345-43f0-a275-91129d5dd3b1',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0005.jpg?alt=media&token=6de8aa15-4345-43f0-a275-91129d5dd3b1'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour6: 
  {
    panoramas   :
    {
      pano01:
      {
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00006%2F01.jpg?alt=media&token=0a6b96b6-dfbf-46da-8102-d499f1133f3c',
      }
    },
    hotspots    :
    [
      
    ],
    info        :
    {
      type        : 'project',
      name        : 'Ilalo Gardens',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información de la casa modelo de 3 dormitorios de Ilalo Gardens',
      whatsapp    : '+593985323724',
      date        : '2021 - 07 - 12',
      ambiente    : 'construcción',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'ilalo gardens casa modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0006.jpg?alt=media&token=e8874f7b-6c4e-49aa-8692-f9f6e4ac9b12',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0006.jpg?alt=media&token=e8874f7b-6c4e-49aa-8692-f9f6e4ac9b12'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour7: 
  {
    panoramas   :
    {
      pano01:
      {
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00007%2F01.jpg?alt=media&token=9d4f420f-39d8-4997-aa75-992a1c44f485',
      }
    },
    hotspots    :
    [
      
    ],
    info        :
    {
      type        : 'house',
      name        : 'Ilalo Gardens',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información de la casa modelo de 3 dormitorios de Ilalo Gardens',
      whatsapp    : '+593985323724',
      date        : '2021 - 07 - 12',
      ambiente    : 'render',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'ilalo gardens casa modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0007.jpg?alt=media&token=3a85b4af-4901-4d80-8bd0-d4c38b6c6e92',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0007.jpg?alt=media&token=3a85b4af-4901-4d80-8bd0-d4c38b6c6e92'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour8: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00008%2Fpano01.jpg?alt=media&token=8edd8358-642f-4e70-a50f-2c5f6bdb50c8',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00008%2Fpano02.jpg?alt=media&token=8e7ef5b5-23cd-4e78-919f-57dd4bdfbc54',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00008%2Fpano03.jpg?alt=media&token=40c384eb-9226-492f-baa5-367d6426ad33',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00008%2Fpano04.jpg?alt=media&token=96d7585f-fcb3-46cb-b049-88b9bd91b04e',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00008%2Fpano05.jpg?alt=media&token=e16e7eca-75ca-40a2-9578-1403eaa703f5',
      },
    },
    hotspots    :
    [
      {
        from            : "01",
        to              : "02",
        hotspotPosition : "8.258 0 2.0139",
        cameraRotation  : "-7.9900"
      },
      {
        from            : "02",
        to              : "01",
        hotspotPosition : "-8.4828 0 -0.5403",
        cameraRotation  : "-4.8600"
      },
      {
        from            : "02",
        to              : "03",
        hotspotPosition : "6.3452 0 5.6558",
        cameraRotation  : "-2.4200"
      },
      {
        from            : "03",
        to              : "02",
        hotspotPosition : "-6.5856 0 -5.3739",
        cameraRotation  : "-5.4600"
      },
      {
        from            : "03",
        to              : "04",
        hotspotPosition : "8.2745 0 1.9447",
        cameraRotation  : "-7.9560"
      },
      {
        from            : "04",
        to              : "03",
        hotspotPosition : "-8.4883 0 -0.4454",
        cameraRotation  : "-4.8680"
      },
      {
        from            : "04",
        to              : "05",
        hotspotPosition : "0.0478 0 -8.4999",
        cameraRotation  : "-6.3520"
      },
      {
        from            : "05",
        to              : "04",
        hotspotPosition : "0.3295 0 8.4936",
        cameraRotation  : "-9.4300"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Azariah',
      description : 'El Proyecto AZARIAH es un complejo de suites y departamentos de dos habitaciones con acabados de lujo, diseñados para asegurar una vista espectacular gracias a sus diseños aterrazados y brindar máxima comodidad a sus residentes.\nPor su excelente ubicación junto a importantes vías de fácil y rápido acceso a Universidades, colegio, hospitales, centros comerciales, bancos y el Aeropuerto sin lugar a dudas será el sitio ideal para vivir en comunidad. Cuenta con una generosa área verde con parque infantil, área de mascotas, una espectacular área comunal y más, el marco perfecto para disfrutar la “Vida al Máximo”.',
      message     : 'Saludos, requiero información del proyecto Azariah, los encontré en 360',
      whatsapp    : '+593985323724',
      date        : '2021 - 09 - 01',
      ambiente    : 'suite',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'azariah suite modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0008.jpg?alt=media&token=e009552e-37c3-48f8-99cd-b87a91df658d',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0008.jpg?alt=media&token=e009552e-37c3-48f8-99cd-b87a91df658d'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour9: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00009%2F001.jpg?alt=media&token=99266038-1ae3-4a2b-a695-a10b4cb4f918',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00009%2F002.jpg?alt=media&token=c9cd40d9-2b50-4af0-ba9b-e3914ac0e383',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00009%2F003.jpg?alt=media&token=572c1645-5029-497e-8f1b-8841ff10ef3c',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-8.4974 0 -0.2107",
        cameraRotation: "1.4060"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-8.4974 0 -0.2107",
        cameraRotation: "1.4060"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "8.4081 0 1.2467",
        cameraRotation: "-1.6840"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.4081 0 1.2467",
        cameraRotation: "-1.6940"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      title       : 'Unique - Apartamento Modelo 01',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'suite',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    data        :
    {
      rooms       : 3,
      baths       : 3,
      parking     : 2,
      area        : 120,
      cost        : 120000,
    },
    images      :
    {
      button    :
      {
        alt         : 'unique apartamento modelo',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0009.jpg?alt=media&token=ab8f83bb-0849-4544-ae57-7b48689c35d8',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0009.jpg?alt=media&token=ab8f83bb-0849-4544-ae57-7b48689c35d8'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour10: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00010%2F001.jpg?alt=media&token=c3568048-de9d-42a8-85a4-eef49b50fe96',
      },
    },
    hotspots    :
    [
      
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      title       : 'Unique - Sala Cine',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'sala cine',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'unique sala cine',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0010.jpg?alt=media&token=d098d0ba-24d7-456d-9ff1-16d3109badfd',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0010.jpg?alt=media&token=d098d0ba-24d7-456d-9ff1-16d3109badfd'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour11: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00011%2F001.jpg?alt=media&token=50952680-a2d7-4a90-a24f-770ec9a39515',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00011%2F002.jpg?alt=media&token=8e3b0707-8b40-4afa-bdf7-4528f052ae2a',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00011%2F003.jpg?alt=media&token=75cd5f78-6ca3-42a8-9b64-ac213a4dce97',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00011%2F004.jpg?alt=media&token=5957c1c2-86f7-4b8f-8341-edcbbc9cfebd',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-8.2247 0 2.1458",
        cameraRotation: "1.7780"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-2.0336 0 8.2531",
        cameraRotation: "2.8760"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-4.7826 0 7.0269",
        cameraRotation: "2.2900"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "7.1579 0 -4.5841",
        cameraRotation: "-1.1080"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "1.815 0 -8.304",
        cameraRotation: "-0.4840"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.0534 0 -2.719",
        cameraRotation: "-1.3160"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      title       : 'Unique - Gimnasio',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'gimnasio',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'unique gimnasio',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0011.jpg?alt=media&token=8b3f97f4-405a-423e-940d-c6ea657b5f38',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0011.jpg?alt=media&token=8b3f97f4-405a-423e-940d-c6ea657b5f38'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }
  },
  tour12: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00012%2F001.jpg?alt=media&token=5570ecbf-5f62-49cd-8225-65f7f0776f16',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00012%2F002.jpg?alt=media&token=427dfa27-6045-4ded-9b21-1212c1585c8d',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00012%2F003.jpg?alt=media&token=0ab0727a-b7cc-4338-9feb-831f41b89c47',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00012%2F004.jpg?alt=media&token=bc708a27-855f-4d21-bee5-5d06acef6318',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00012%2F005.jpg?alt=media&token=f1b0057a-271b-404e-a213-f158108ac06c',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-8.489 0 -0.4316",
        cameraRotation: "1.5840"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-8.4991 0 -0.1258",
        cameraRotation: "1.6300"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-8.4582 0 0.8418",
        cameraRotation: "1.7580"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "-7.9455 0 3.0198",
        cameraRotation: "1.8780"
      },
      {
        from: "05",
        to: "04",
        hotspotPosition: "8.4339 0 -1.058",
        cameraRotation: "4.8020"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "8.4339 0 -1.058",
        cameraRotation: "4.8280"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "8.465 0 -0.7707",
        cameraRotation: "4.6920"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.4772 0 0.6217",
        cameraRotation: "4.7080"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      title       : 'Unique - Entrada',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'entrada',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'unique entrada',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0012.jpg?alt=media&token=ba5791eb-e6cb-48b4-9387-626e3005fe47',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0012.jpg?alt=media&token=ba5791eb-e6cb-48b4-9387-626e3005fe47'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }  
  },
  tour13: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00013%2F001.jpg?alt=media&token=03b49296-f047-4a7c-80c9-9ebba71eaa18',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00013%2F002.jpg?alt=media&token=84e2d8e8-b682-47c8-8804-85e99f468f4d',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00013%2F003.jpg?alt=media&token=fa068a31-fbe2-46ad-a91e-9a2a64a57fce',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00013%2F004.jpg?alt=media&token=587df27a-f8af-45a8-bc54-ddfe8fea9118',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00013%2F005.jpg?alt=media&token=6a704d5e-b165-4fcf-ae44-72e2f7743b0b',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-8.3757 0 1.4481",
        cameraRotation: "1.6660"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-8.4516 0 -0.906",
        cameraRotation: "1.1320"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-3.7583 0 -7.624",
        cameraRotation: "0.4920"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "-3.7583 0 -7.624",
        cameraRotation: "0.6720"
      },
      {
        from: "05",
        to: "04",
        hotspotPosition: "5.6329 0 6.3656",
        cameraRotation: "3.5900"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "4.3877 0 7.28",
        cameraRotation: "3.4580"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "7.7599 0 3.469",
        cameraRotation: "4.1380"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.2019 0 -2.2312",
        cameraRotation: "4.8660"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      title       : 'Unique - Piscina',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'piscina',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'unique piscina',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0013.jpg?alt=media&token=5c03540a-61bf-4918-80bd-497edcd290cc',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0013.jpg?alt=media&token=5c03540a-61bf-4918-80bd-497edcd290cc'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }  
  },
  tour14: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F001.jpg?alt=media&token=f69d1e4b-7a96-44c5-898b-437cc6647328',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F002.jpg?alt=media&token=744ed586-c4a5-457f-9077-752e2be6d7da',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F003.jpg?alt=media&token=221c7b9f-cffe-4876-8dc6-51c281aa9120',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F004.jpg?alt=media&token=1115e9da-6cab-48c4-90da-58a62caea2da',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F005.jpg?alt=media&token=222dd8b8-cd38-43d4-8f38-2440ff62fe55',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F006.jpg?alt=media&token=ad47bf5a-45d5-475c-b22c-a8635cabda56',
      },
      pano07:
      {
        id    : 'pano07',
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00014%2F007.jpg?alt=media&token=b30e5285-8ecc-45a8-b660-20f7ed799435',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-7.7654 0 -3.4566",
        cameraRotation: "1.0980"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-6.8522 0 5.0297",
        cameraRotation: "1.9120"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-3.9371 0 7.5332",
        cameraRotation: "2.6060"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "-0.5571 0 8.4817",
        cameraRotation: "-3.2480"
      },
      {
        from: "05",
        to: "06",
        hotspotPosition: "7.3748 0 4.2264",
        cameraRotation: "-2.0340"
      },
      {
        from: "06",
        to: "07",
        hotspotPosition: "7.4579 0 4.078",
        cameraRotation: "-1.9940"
      },
      {
        from: "07",
        to: "06",
        hotspotPosition: "-6.3067 0 -5.6987",
        cameraRotation: "0.8000"
      },
      {
        from: "06",
        to: "05",
        hotspotPosition: "-6.3971 0 -5.5971",
        cameraRotation: "0.5800"
      },
      {
        from: "05",
        to: "04",
        hotspotPosition: "3.0102 0 -7.9491",
        cameraRotation: "-0.5360"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "4.3263 0 -7.3166",
        cameraRotation: "-0.6140"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "8.0717 0 -2.6641",
        cameraRotation: "-1.1280"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.0545 0 2.7158",
        cameraRotation: "-2.1180"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      title       : 'Unique - Terraza',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'terraza',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'unique terraza',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0014.jpg?alt=media&token=b1ff5c40-47c7-4550-9e7d-2311e94eb909',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0014.jpg?alt=media&token=b1ff5c40-47c7-4550-9e7d-2311e94eb909'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }  
  },
  tour15: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F001.jpg?alt=media&token=92372734-0060-41a4-ae42-b08105ecde2b',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F002.jpg?alt=media&token=33efe824-714f-4cc5-b371-129687c5f6ff',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F003.jpg?alt=media&token=911c460a-b771-4141-9c73-3c8699a98b98',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F004.jpg?alt=media&token=571ba2d3-fd92-4214-8b6b-1f78458a7d68',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F005.jpg?alt=media&token=44c951be-52a1-401e-910c-c65bf4bb2d23',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F006.jpg?alt=media&token=ebc92e90-2b80-4a5b-93b7-b0b2004ce163',
      },
      pano07:
      {
        id    : 'pano07',
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F007.jpg?alt=media&token=f8d1d280-0bec-498b-a540-03dc10f13348',
      },
      pano08:
      {
        id    : 'pano08',
        pano  : '08',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F008.jpg?alt=media&token=d44b36ef-8e7f-46e2-8160-35be2f046251',
      },
      pano09:
      {
        id    : 'pano09',
        pano  : '09',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F009.jpg?alt=media&token=2806fc70-1378-4c52-8083-068af455ff5b',
      },
      pano10:
      {
        id    : 'pano10',
        pano  : '10',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F010.jpg?alt=media&token=869a71e1-c988-435a-a4f5-605af9d00d72',
      },
      pano11:
      {
        id    : 'pano11',
        pano  : '11',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F011.jpg?alt=media&token=a57f8833-3894-4616-9331-6c81161a373f',
      },
      pano12:
      {
        id    : 'pano12',
        pano  : '12',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F012.jpg?alt=media&token=55303d24-199c-4432-bd1c-00a5a468a9f5',
      },
      pano13:
      {
        id    : 'pano13',
        pano  : '13',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F013.jpg?alt=media&token=f2915707-f65b-4128-a99a-39af5b09aeec',
      },
      pano14:
      {
        id    : 'pano14',
        pano  : '14',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F014.jpg?alt=media&token=978102c7-85f9-4fba-8a9d-3d238a55eb60',
      },
      pano15:
      {
        id    : 'pano15',
        pano  : '15',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F015.jpg?alt=media&token=c69e7d45-60f4-4135-969b-9fb1091df2a6',
      },
      pano16:
      {
        id    : 'pano16',
        pano  : '16',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F016.jpg?alt=media&token=372ee5f0-8e37-41c5-8e34-d4f369a9dced',
      },
      pano17:
      {
        id    : 'pano17',
        pano  : '17',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F017.jpg?alt=media&token=5f8c0840-f0f2-42d8-81cd-de3c26ec5f62',
      },
      pano18:
      {
        id    : 'pano18',
        pano  : '18',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F018.jpg?alt=media&token=838696b7-4591-4a90-950a-1eda485ea384',
      },
      pano19:
      {
        id    : 'pano19',
        pano  : '19',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F019.jpg?alt=media&token=0895e500-5353-42d1-b7b2-80f4902966cf',
      },
      pano20:
      {
        id    : 'pano20',
        pano  : '20',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F020.jpg?alt=media&token=d9460ff4-efc5-4a39-aed0-cd8509e647df',
      },
      pano21:
      {
        id    : 'pano21',
        pano  : '21',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F021.jpg?alt=media&token=9b8125e2-a55c-425e-8713-a13fdc7285f4',
      },
      pano22:
      {
        id    : 'pano22',
        pano  : '22',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00015%2F022.jpg?alt=media&token=c5a29240-86cc-487a-ae25-e7438eadba05',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "06",
        hotspotPosition: "-8.3876 0 -1.3777",
        cameraRotation: "-2.4060"
      },
      {
        from: "01",
        to: "17",
        hotspotPosition: "-1.4883 0 -8.3687",
        cameraRotation: "-0.2580"
      },
      {
        from: "01",
        to: "07",
        hotspotPosition: "-8.3699 0 1.4816",
        cameraRotation: "-0.9880"
      },
      {
        from: "01",
        to: "04",
        hotspotPosition: "2.5963 0 8.0938",
        cameraRotation: "-3.2560"
      },
      {
        from: "17",
        to: "01",
        hotspotPosition: "-2.8153 0 8.0202",
        cameraRotation: "-3.0060"
      },
      {
        from: "06",
        to: "07",
        hotspotPosition: "-4.9664 0 -6.8982",
        cameraRotation: "2.0420"
      },
      {
        from: "07",
        to: "06",
        hotspotPosition: "8.483 0 0.5369",
        cameraRotation: "3.4060"
      },
      {
        from: "07",
        to: "01",
        hotspotPosition: "-7.3287 0 4.3059",
        cameraRotation: "4.9340"
      },
      {
        from: "07",
        to: "17",
        hotspotPosition: "0.0715 0 8.4997",
        cameraRotation: "5.7360"
      },
      {
        from: "07",
        to: "04",
        hotspotPosition: "-7.8461 0 -3.2693",
        cameraRotation: "3.8800"
      },
      {
        from: "07",
        to: "08",
        hotspotPosition: "1.4883 0 -8.3687",
        cameraRotation: "5.9720"
      },
      {
        from: "06",
        to: "08",
        hotspotPosition: "1.1693 0 -8.4192",
        cameraRotation: "0.8020"
      },
      {
        from: "08",
        to: "07",
        hotspotPosition: "-0.0545 0 8.4998",
        cameraRotation: "3.4000"
      },
      {
        from: "08",
        to: "09",
        hotspotPosition: "-1.0782 0 -8.4313",
        cameraRotation: "3.1720"
      },
      {
        from: "09",
        to: "08",
        hotspotPosition: "0.0579 0 -8.4998",
        cameraRotation: "3.4040"
      },
      {
        from: "08",
        to: "10",
        hotspotPosition: "-8.0458 0 2.7414",
        cameraRotation: "1.6440"
      },
      {
        from: "10",
        to: "08",
        hotspotPosition: "8.4192 0 -1.1691",
        cameraRotation: "5.0460"
      },
      {
        from: "10",
        to: "04",
        hotspotPosition: "-8.4653 0 0.7673",
        cameraRotation: "4.6600"
      },
      {
        from: "10",
        to: "11",
        hotspotPosition: "-0.5537 0 -8.4819",
        cameraRotation: "1.5260"
      },
      {
        from: "11",
        to: "10",
        hotspotPosition: "8.4941 0 0.3162",
        cameraRotation: "3.2540"
      },
      {
        from: "04",
        to: "01",
        hotspotPosition: "-0.6284 0 -8.4767",
        cameraRotation: "0.1820"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "4.7685 0 7.0364",
        cameraRotation: "-0.1480"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "-0.3604 0 8.4924",
        cameraRotation: "3.1200"
      },
      {
        from: "04",
        to: "10",
        hotspotPosition: "-8.477 0 -0.6251",
        cameraRotation: "-1.3900"
      },
      {
        from: "04",
        to: "12",
        hotspotPosition: "8.4706 0 0.7064",
        cameraRotation: "-5.3580"
      },
      {
        from: "05",
        to: "04",
        hotspotPosition: "0.4418 0 -8.4885",
        cameraRotation: "-6.2600"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "1.951 0 8.2731",
        cameraRotation: "1.2800"
      },
      {
        from: "12",
        to: "04",
        hotspotPosition: "7.3063 0 4.3438",
        cameraRotation: "1.5060"
      },
      {
        from: "12",
        to: "18",
        hotspotPosition: "-6.4283 0 5.5612",
        cameraRotation: "0.8060"
      },
      {
        from: "12",
        to: "13",
        hotspotPosition: "-5.1711 0 -6.7461",
        cameraRotation: "1.3360"
      },
      {
        from: "18",
        to: "19",
        hotspotPosition: "6.166 0 -5.8507",
        cameraRotation: "-1.4940"
      },
      {
        from: "18",
        to: "12",
        hotspotPosition: "3.2313 0 7.8618",
        cameraRotation: "-0.9620"
      },
      {
        from: "19",
        to: "20",
        hotspotPosition: "-0.801 0 -8.4622",
        cameraRotation: "1.5520"
      },
      {
        from: "19",
        to: "18",
        hotspotPosition: "-8.3947 0 1.3338",
        cameraRotation: "2.4580"
      },
      {
        from: "20",
        to: "19",
        hotspotPosition: "8.4861 0 -0.4857",
        cameraRotation: "3.1660"
      },
      {
        from: "13",
        to: "12",
        hotspotPosition: "8.3903 0 1.3612",
        cameraRotation: "4.0500"
      },
      {
        from: "13",
        to: "14",
        hotspotPosition: "-8.2555 0 -2.024",
        cameraRotation: "7.7660"
      },
      {
        from: "13",
        to: "15",
        hotspotPosition: "0.0478 0 -8.4999",
        cameraRotation: "7.7660"
      },
      {
        from: "14",
        to: "13",
        hotspotPosition: "8.3552 0 1.5622",
        cameraRotation: "4.4480"
      },
      {
        from: "15",
        to: "13",
        hotspotPosition: "8.4803 0 0.5777",
        cameraRotation: "3.0140"
      },
      {
        from: "15",
        to: "16",
        hotspotPosition: "3.6267 0 -7.6874",
        cameraRotation: "2.6340"
      },
      {
        from: "15",
        to: "02",
        hotspotPosition: "-2.1063 0 8.2349",
        cameraRotation: "5.6680"
      },
      {
        from: "15",
        to: "21",
        hotspotPosition: "-8.4976 0 -0.2007",
        cameraRotation: "5.0680"
      },
      {
        from: "16",
        to: "15",
        hotspotPosition: "7.3596 0 -4.2528",
        cameraRotation: "2.4100"
      },
      {
        from: "02",
        to: "15",
        hotspotPosition: "-1.7155 0 8.3251",
        cameraRotation: "0.4400"
      },
      {
        from: "21",
        to: "15",
        hotspotPosition: "-7.7488 0 3.4937",
        cameraRotation: "-1.5820"
      },
      {
        from: "21",
        to: "22",
        hotspotPosition: "0.0478 0 -8.4999",
        cameraRotation: "0.3960"
      },
      {
        from: "22",
        to: "21",
        hotspotPosition: "-0.1873 0 8.4979",
        cameraRotation: "3.4100"
      }
    ],
    info        :
    {
      type        : 'apartment',
      name        : 'Qualitá',
      description : 'Apartamento en VENTA',
      message     : 'Saludos, requiero información del apartamento',
      whatsapp    : '+593983207391',
      date        : '2021 - 10 - 29',
      ambiente    : 'apartmento',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    data        :
    {
      rooms       : 3,
      baths       : 3,
      parking     : 2,
      area        : 190,
      cost        : 245000,
    },
    images      :
    {
      button    :
      {
        alt         : 'quialita apartamento',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0015.jpg?alt=media&token=15cd9daa-28cd-4f11-b494-e2a1570b960e',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0015.jpg?alt=media&token=15cd9daa-28cd-4f11-b494-e2a1570b960e'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }  
  },
  tour16: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F001.jpg?alt=media&token=6ae2922f-ca7d-4108-9456-f57a3d9c2405',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F002.jpg?alt=media&token=56beabe5-b3e3-4fa6-9263-48c653f96225',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F003.jpg?alt=media&token=aa75afef-c545-40fa-bdb8-cb9574c2468c',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F004.jpg?alt=media&token=26661521-1c73-40a5-8671-76b677da3bf7',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F005.jpg?alt=media&token=753ae3a6-b532-41c5-af45-8c36ae67c092',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F006.jpg?alt=media&token=b5a69b3a-7f4f-4e6b-a50a-7be2d5620434',
      },
      pano07:
      {
        id    : 'pano07',
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F007.jpg?alt=media&token=d763bf98-8bdc-4684-83b8-3da952d56dac',
      },
      pano08:
      {
        id    : 'pano08',
        pano  : '08',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F008.jpg?alt=media&token=e08a7fac-6c35-4c1c-beea-f761e9d24bf2',
      },
      pano09:
      {
        id    : 'pano09',
        pano  : '09',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00016%2F009.jpg?alt=media&token=ddeed2da-679d-4e29-abf1-d07f5b402011',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-5.3315 0 -6.62",
        cameraRotation: "0.1420"
      },
      {
        from: "01",
        to: "09",
        hotspotPosition: "-8.4634 0 -0.7876",
        cameraRotation: "-0.0900"
      },
      {
        from: "02",
        to: "09",
        hotspotPosition: "-8.3978 0 1.3139",
        cameraRotation: "0.6800"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "2.2214 0 8.2046",
        cameraRotation: "3.8260"
      },
      {
        from: "09",
        to: "01",
        hotspotPosition: "0.1565 0 8.4986",
        cameraRotation: "-1.6100"
      },
      {
        from: "09",
        to: "02",
        hotspotPosition: "5.9803 0 6.0403",
        cameraRotation: "-1.2280"
      },
      {
        from: "01",
        to: "03",
        hotspotPosition: "0.248 0 -8.4964",
        cameraRotation: "0.0660"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-4.4836 0 -7.2213",
        cameraRotation: "0.9580"
      },
      {
        from: "03",
        to: "05",
        hotspotPosition: "8.4612 0 0.8111",
        cameraRotation: "1.5400"
      },
      {
        from: "03",
        to: "07",
        hotspotPosition: "2.4405 0 8.1421",
        cameraRotation: "3.2000"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "4.5441 0 7.1834",
        cameraRotation: "3.3220"
      },
      {
        from: "05",
        to: "03",
        hotspotPosition: "8.4959 0 -0.2655",
        cameraRotation: "-4.6520"
      },
      {
        from: "05",
        to: "06",
        hotspotPosition: "0.7643 0 8.4656",
        cameraRotation: "-2.6780"
      },
      {
        from: "06",
        to: "05",
        hotspotPosition: "-4.1912 0 -7.3949",
        cameraRotation: "-6.2020"
      },
      {
        from: "03",
        to: "01",
        hotspotPosition: "-6.1679 0 5.8486",
        cameraRotation: "-9.4340"
      },
      {
        from: "07",
        to: "08",
        hotspotPosition: "-8.4368 0 1.0346",
        cameraRotation: "-9.3940"
      },
      {
        from: "08",
        to: "07",
        hotspotPosition: "-0.0409 0 -8.4999",
        cameraRotation: "-7.7580"
      },
      {
        from: "07",
        to: "03",
        hotspotPosition: "0.8924 0 -8.453",
        cameraRotation: "-6.0640"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Parques de Galicia 2',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Parques de Galicia 2',
      whatsapp    : '+593997100702',
      date        : null,
      ambiente    : 'casa modelo',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'parques de galicia 2',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0016.jpg?alt=media&token=e76ad1ea-709e-448a-9006-2f557affa4e3',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0016.jpg?alt=media&token=e76ad1ea-709e-448a-9006-2f557affa4e3'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    },
    credits     :
    {
      creator   : 'entorno',
      urlPC     : '',
      urlPhone  : '',
    }
  },
  tour17: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F001.jpg?alt=media&token=d06e8b23-8ed1-422c-ba7d-d0984b4deedb',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F002.jpg?alt=media&token=cb595236-5716-4234-a68d-b7187a4d8949',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F003.jpg?alt=media&token=fe7211f7-a1de-4acc-b8d4-b8b089cc3267',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F004.jpg?alt=media&token=df3dd02f-ed91-462a-8b47-bfb6582838a3',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F005.jpg?alt=media&token=2df85e4b-edc7-4c5c-8c9d-11003e0f9118',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F006.jpg?alt=media&token=1fe596c2-bf2c-4db3-911e-7c1e5293acfb',
      },
      pano07:
      {
        id    : 'pano07',
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F007.jpg?alt=media&token=ce969f8a-4c83-4971-aef6-cb065597bc6a',
      },
      pano08:
      {
        id    : 'pano08',
        pano  : '08',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00017%2F008.jpg?alt=media&token=39e42403-0154-4ad6-a017-f67c90d0fdd2',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "03",
        hotspotPosition: "-4.2205 0 7.3782",
        cameraRotation: "1.6120"
      },
      {
        from: "01",
        to: "02",
        hotspotPosition: "2.9976 0 7.9539",
        cameraRotation: "1.2680"
      },
      {
        from: "01",
        to: "08",
        hotspotPosition: "7.4167 0 4.1524",
        cameraRotation: "-0.0320"
      },
      {
        from: "02",
        to: "08",
        hotspotPosition: "-5.6022 0 6.3926",
        cameraRotation: "-0.0320"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "8.4501 0 0.9195",
        cameraRotation: "0.2520"
      },
      {
        from: "08",
        to: "02",
        hotspotPosition: "2.0568 0 8.2474",
        cameraRotation: "-0.7260"
      },
      {
        from: "08",
        to: "01",
        hotspotPosition: "-1.3172 0 8.3973",
        cameraRotation: "1.0320"
      },
      {
        from: "03",
        to: "01",
        hotspotPosition: "4.3936 0 7.2764",
        cameraRotation: "-0.4720"
      },
      {
        from: "03",
        to: "05",
        hotspotPosition: "-5.4679 0 6.5078",
        cameraRotation: "0.9360"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "-6.1846 0 -5.831",
        cameraRotation: "-0.5360"
      },
      {
        from: "03",
        to: "06",
        hotspotPosition: "0.1631 0 -8.4984",
        cameraRotation: "3.5020"
      },
      {
        from: "03",
        to: "07",
        hotspotPosition: "8.4991 0 0.1223",
        cameraRotation: "1.5000"
      },
      {
        from: "05",
        to: "03",
        hotspotPosition: "3.0928 0 7.9174",
        cameraRotation: "5.1320"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "-3.5866 0 7.7063",
        cameraRotation: "-2.2740"
      },
      {
        from: "06",
        to: "03",
        hotspotPosition: "-3.9552 0 -7.5237",
        cameraRotation: "-3.0560"
      },
      {
        from: "07",
        to: "03",
        hotspotPosition: "7.4789 0 4.0393",
        cameraRotation: "1.6120"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Parques de Girona',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Parques de Girona 2',
      whatsapp    : '+593997100702',
      date        : null,
      ambiente    : 'casa modelo',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'parques de girona 2',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0017.jpg?alt=media&token=87709222-d023-44f4-aee2-aecc6f6e9021',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0017.jpg?alt=media&token=87709222-d023-44f4-aee2-aecc6f6e9021'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    },
    credits     :
    {
      creator   : 'entorno',
      urlPC     : '',
      urlPhone  : '',
    }
  },
  tour18: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F001.jpg?alt=media&token=3706ba06-eed9-4ee2-898f-570100209084',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F002.jpg?alt=media&token=93f88caa-1ada-4a68-b08f-e34dd008c093',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F003.jpg?alt=media&token=32086e06-8b45-4174-ade9-2244cef8d69f',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F004.jpg?alt=media&token=c911a654-c3c0-451b-a4fc-8eb9f2a6cf74',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F005.jpg?alt=media&token=ce1b9e7b-a0bf-4998-90ec-f88b26d697cb',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F006.jpg?alt=media&token=1d060dc7-aeac-478e-aa3b-63e385139e59',
      },
      pano07:
      {
        id    : 'pano07',
        pano  : '07',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F007.jpg?alt=media&token=a7058b9e-7be1-4f82-b9de-453d8257dcdc',
      },
      pano08:
      {
        id    : 'pano08',
        pano  : '08',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F008.jpg?alt=media&token=c91b475a-307c-4578-8963-c708fc18fc17',
      },
      pano09:
      {
        id    : 'pano09',
        pano  : '09',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F009.jpg?alt=media&token=5b11d45e-dbec-4f4f-a172-5cd4bb72599f',
      },
      pano10:
      {
        id    : 'pano10',
        pano  : '10',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F010.jpg?alt=media&token=3f68bfa5-6cc6-477f-b71a-4ff036651730',
      },
      pano11:
      {
        id    : 'pano11',
        pano  : '11',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00018%2F011.jpg?alt=media&token=1c778e9a-ad31-44a6-9c15-79e5e09ae77d',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "-8.4772 0 0.6217",
        cameraRotation: "-1.4280"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "-8.4981 0 0.1802",
        cameraRotation: "-1.4340"
      },
      {
        from: "02",
        to: "06",
        hotspotPosition: "-0.3909 0 -8.491",
        cameraRotation: "1.7840"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "8.1857 0 -2.2901",
        cameraRotation: "3.2940"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "8.382 0 -1.4112",
        cameraRotation: "1.6400"
      },
      {
        from: "03",
        to: "05",
        hotspotPosition: "1.2332 0 8.4101",
        cameraRotation: "1.6120"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "8.4736 0 -0.6691",
        cameraRotation: "1.6780"
      },
      {
        from: "04",
        to: "05",
        hotspotPosition: "2.2672 0 -8.1921",
        cameraRotation: "1.6420"
      },
      {
        from: "05",
        to: "04",
        hotspotPosition: "8.3608 0 1.5318",
        cameraRotation: "3.0720"
      },
      {
        from: "05",
        to: "03",
        hotspotPosition: "8.3258 0 -1.712",
        cameraRotation: "0.0700"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "-1.7719 0 -8.3133",
        cameraRotation: "1.6940"
      },
      {
        from: "06",
        to: "02",
        hotspotPosition: "2.8667 0 -8.002",
        cameraRotation: "-2.9740"
      },
      {
        from: "06",
        to: "09",
        hotspotPosition: "-6.9239 0 -4.9305",
        cameraRotation: "-0.8280"
      },
      {
        from: "06",
        to: "08",
        hotspotPosition: "-4.1909 0 7.395",
        cameraRotation: "1.4420"
      },
      {
        from: "06",
        to: "07",
        hotspotPosition: "2.3197 0 8.1774",
        cameraRotation: "1.2760"
      },
      {
        from: "06",
        to: "10",
        hotspotPosition: "7.8036 0 -3.3695",
        cameraRotation: "3.3020"
      },
      {
        from: "07",
        to: "06",
        hotspotPosition: "8.3621 0 1.525",
        cameraRotation: "0.1800"
      },
      {
        from: "08",
        to: "06",
        hotspotPosition: "7.8669 0 3.2189",
        cameraRotation: "-0.5880"
      },
      {
        from: "09",
        to: "06",
        hotspotPosition: "-5.8236 0 6.1916",
        cameraRotation: "-2.2740"
      },
      {
        from: "10",
        to: "11",
        hotspotPosition: "8.3379 0 -1.6521",
        cameraRotation: "-4.4600"
      },
      {
        from: "11",
        to: "10",
        hotspotPosition: "8.2408 0 -2.0833",
        cameraRotation: "-4.5780"
      },
      {
        from: "10",
        to: "06",
        hotspotPosition: "-0.1429 0 -8.4988",
        cameraRotation: "-4.5320"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Parques de Miranda',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Parques de Miranda',
      whatsapp    : '+593997100702',
      date        : null,
      ambiente    : 'casa modelo',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'parques de miranda',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0018.jpg?alt=media&token=3d45361a-0e89-4b28-b2fa-b7810cd16c32',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0018.jpg?alt=media&token=3d45361a-0e89-4b28-b2fa-b7810cd16c32'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    },
    credits     :
    {
      creator   : 'entorno',
      urlPC     : '',
      urlPhone  : '',
    }
  },
  tour19: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00019%2F001.jpg?alt=media&token=64bcd410-9c86-4239-a87e-1aeb00b60fa3',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00019%2F002.jpg?alt=media&token=66aa7df1-7c47-4682-b221-6fb206d476fb',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00019%2F003.jpg?alt=media&token=d1943555-6c08-465a-805e-c8598a6d7523',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "3.7614 0 7.6224",
        cameraRotation: "3.0860"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "-3.3477 0 -7.813",
        cameraRotation: "0.1860"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "-8.4755 0 -0.6452",
        cameraRotation: "1.5600"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "8.4757 0 -0.6421",
        cameraRotation: "4.6080"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Parques de Girona',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Parques de Girona 2',
      whatsapp    : '+593997100702',
      date        : null,
      ambiente    : 'parque',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'parques de girona',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0019.jpg?alt=media&token=3b0bdd36-c641-4272-8e03-2e7c827ad3e6',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0019.jpg?alt=media&token=3b0bdd36-c641-4272-8e03-2e7c827ad3e6'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    },
    credits     :
    {
      creator   : 'entorno',
      urlPC     : '',
      urlPhone  : '',
    }
  },
  tour20: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00020%2F001.jpg?alt=media&token=18d37e1c-913f-4bad-8b08-7ac3b8155f22',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00020%2F002.jpg?alt=media&token=a4acc2c9-2519-4e84-89ee-48eac511f7f7',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00020%2F003.jpg?alt=media&token=cc63733d-b6dc-47c3-bfa2-e508af67c264',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : 'https://firebasestorage.googleapis.com/v0/b/entorno-io.appspot.com/o/toursen360%2Ftour00020%2F004.jpg?alt=media&token=9efdce33-4317-4097-b1df-6b678da214bf',
      },
    },
    hotspots    :
    [
      {
        from: "01",
        to: "02",
        hotspotPosition: "8.413 0 1.2131",
        cameraRotation: "-1.6860"
      },
      {
        from: "02",
        to: "01",
        hotspotPosition: "-8.4988 0 -0.1428",
        cameraRotation: "1.3720"
      },
      {
        from: "02",
        to: "03",
        hotspotPosition: "8.4999 0 0.0442",
        cameraRotation: "-1.6140"
      },
      {
        from: "03",
        to: "02",
        hotspotPosition: "-8.4936 0 -0.3297",
        cameraRotation: "1.3880"
      },
      {
        from: "03",
        to: "04",
        hotspotPosition: "8.4808 0 0.5708",
        cameraRotation: "-1.6900"
      },
      {
        from: "04",
        to: "03",
        hotspotPosition: "-8.4949 0 -0.2957",
        cameraRotation: "-4.8100"
      }
    ],
    info        :
    {
      type        : 'project',
      name        : 'Parques de Girona',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Parques de Girona 2',
      whatsapp    : '+593997100702',
      date        : null,
      ambiente    : 'vía',
      qr          : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/qr%2Fparquesdegirona.png?alt=media&token=0042c62b-d314-474d-a9b0-7801761f24ab'
    },
    images      :
    {
      button    :
      {
        alt         : 'parques de girona via',
        image       : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0020.jpg?alt=media&token=bcb30164-654c-4f0f-ba44-cfa3d4314efc',
        placeholder : 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/thumbnails%2Ftour0020.jpg?alt=media&token=bcb30164-654c-4f0f-ba44-cfa3d4314efc'
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    },
    credits     :
    {
      creator   : 'entorno',
      urlPC     : '',
      urlPhone  : '',
    }
  },
  tour30: 
  {
    panoramas   :
    {
      pano01:
      {
        id    : 'pano01',
        pano  : '01',
        url   : '',
      },
      pano02:
      {
        id    : 'pano02',
        pano  : '02',
        url   : '',
      },
      pano03:
      {
        id    : 'pano03',
        pano  : '03',
        url   : '',
      },
      pano04:
      {
        id    : 'pano04',
        pano  : '04',
        url   : '',
      },
      pano05:
      {
        id    : 'pano05',
        pano  : '05',
        url   : '',
      },
      pano06:
      {
        id    : 'pano06',
        pano  : '06',
        url   : '',
      },
      pano07:
      {
        id    : 'pano07',
        pano  : '07',
        url   : '',
      },
    },
    hotspots    :
    [
      
    ],
    info        :
    {
      type        : 'project',
      name        : 'Unique',
      description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      message     : 'Saludos, requiero información del proyecto Unique',
      whatsapp    : '+593992576900',
      date        : '2021 - 09 - 27',
      ambiente    : 'terraza',
    },
    images      :
    {
      button    :
      {
        alt         : 'unique terraza',
        image       : null,
        placeholder : null
      },
      thumbnail :
      {
        image       : null,
        placeholder : null
      }
    }  
  },
}

export default Tours;